import * as React from "react";
import {Select} from "antd";
import locales from "../locales";

const {Option} = Select;

export enum FeatureFilter {
  ALL = 'ALL',
  WITH_FEATURE = 'WITH_FEATURE',
  WITHOUT_FEATURE = 'WITHOUT_FEATURE',
}

export const getMaintenanceSheetFilterOptions = (): React.ReactNode[] => [
  getOption(locales.show_all_item, FeatureFilter.ALL),
  getOption(locales.show_with_maintenance_sheet, FeatureFilter.WITH_FEATURE),
  getOption(locales.show_without_maintenance_sheet, FeatureFilter.WITHOUT_FEATURE),
];

const getOption = (label: string, value: FeatureFilter): React.ReactNode => (
  <Option value={value} key={value}>{label}</Option>
);


// WEBPACK FOOTER //
// ./src/common/FeatureFilter.tsx